module.exports = __webpack_public_path__ + "static/media/circle.a3ff2eba.svg";